/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h, render } from "preact";
import styled from "styled-px2rem";
import { Mask, Toast } from "antd-mobile";
import { useState, useEffect } from "preact/hooks";
import TbIconSrc from "@images/icon/tb_big.png";
import CancleIconSrc from "@images/icon/ic_cancel.png";
import "./signpop.css";
const MaskWrap = ({ type,integral,callBack,bloggerNickName,goodsInfo }: any) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        setVisible(true);
    }, [])
    return (<Mask className="z_9999" visible={visible} disableBodyScroll={true}>
        <Container>
            {
                type == 1 && <Content className="sign_pop">
                    <JfNumber>+{integral}</JfNumber>
                    <SubTitle>明天继续签到可获得更多积分</SubTitle>
                    <CloseBtn onClick={() => {
                        const ContainerDiv: any = document.getElementById("container");
                        render(null, ContainerDiv);
                    }} />
                </Content>
            }
             {
                type == 2 && <TbContent>
                    <TbIcon src={TbIconSrc} />
                    <TbTitle>
                    积分是【{bloggerNickName}】给宝们的福利<br/>可用于免费兑换礼品
                    </TbTitle>
                    <TbSubTitle>开通后收到淘宝政策规定宝子首次购买淘宝商品会进行一次授权，授权后每次购买商品都会返等额积分！</TbSubTitle>
                    <TbBottomWrap>
                        <TbBtnNormal onClick={()=>{
                            const ContainerDiv: any = document.getElementById("container");
                            render(null, ContainerDiv);
                        }}>点错了</TbBtnNormal>
                        <TbBtnActive onClick={()=>{
                            callBack();
                            const ContainerDiv: any = document.getElementById("container");
                            render(null, ContainerDiv);
                        }}>立即开启</TbBtnActive>
                    </TbBottomWrap>
                </TbContent>
            }
             {
                type==3&&<LoadingPop className="pop_bg">
                    <LoadingWrap>
                        <LoadingIcon src={goodsInfo.imgUrl} />
                        <InfoTitle>{goodsInfo.text}</InfoTitle>
                    </LoadingWrap>
                </LoadingPop>
            }
            {
                type==1&&<CancleIcon src={CancleIconSrc}  onClick={()=>{
                    const ContainerDiv: any = document.getElementById("container");
                    render(null, ContainerDiv);
                }}/>
            }

        </Container>
    </Mask>);
}
const SignPop = {
    close: () => {
        const ContainerDiv: any = document.getElementById("container");
        render(null, ContainerDiv);
    },
    showSignIn: (type=1,integral=0,callBack=()=>{}) => {
        const ContainerDiv: any = document.getElementById("container");
        render(<MaskWrap type={type} integral={integral} callBack={callBack} />, ContainerDiv);
    },
    showConfirm: (type=1,integral=0,bloggerNickName="博主",callBack=()=>{}) => {
        const ContainerDiv: any = document.getElementById("container");
        render(<MaskWrap type={type} integral={integral} bloggerNickName={bloggerNickName} callBack={callBack} />, ContainerDiv);
    },
    showPop:(type=1,goodsInfo={}) => {
        const ContainerDiv: any = document.getElementById("container");
        setTimeout(()=>{
            render(null, ContainerDiv);
        },2000)
        render(<MaskWrap type={type} goodsInfo={goodsInfo} />, ContainerDiv);
    },
};
export default SignPop;
const Container = styled.div`
    width:100vw;
    height:100vh;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
`;
const CancleIcon=styled.img`
    margin-top:56px;
    width: 44px;
    height: 44px;
`
const Content = styled.div`
    position: relative;
    width: 560px;
    height: 675px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const JfNumber = styled.div`
    margin-top:311px;
    font-weight: 600;
    color: #FE724A;
    font-size:100px;
    line-height:140px;
`;
const SubTitle = styled.div`
    margin-top:40px;
    font-weight: 500;
    color: #666666;
    line-height: 33px;
    font-size:24px;
`;
const CloseBtn = styled.div`
    position: absolute;
    left: 105px;
    bottom: 34px;
    width: 350px;
    height: 84px;
`;
const TbContent=styled.div`
    width: 560px;
    height: 574px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 40px 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const TbIcon=styled.img`
    width: 120px;
    height: 120px;
`;
const TbTitle=styled.div`
    margin-top:32px;
    width: 100%;
    font-weight: 600;
    color: #333333;
    font-size:28px;
    text-align: center;
`;
const TbSubTitle=styled.div`
    margin-top:32px;
    font-weight: 400;
    color: #666666;
    line-height: 33px;
    font-size:24px;
`;
const TbBottomWrap=styled.div`
    margin-top:auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;
const TbBtnNormal=styled.div`
    width: 236px;
    height: 88px;
    background: #E0E0E0;
    border-radius: 44px;
    font-weight: 500;
    color: #999999;
    font-size:30px;
    text-align: center;
    line-height: 88px;
`;
const TbBtnActive=styled.div`
width: 236px;
height: 88px;
background: linear-gradient(90deg, #FF9059 0%, #FA483E 100%);border-radius: 44px;
font-weight: 500;
color: #fff;
font-size:30px;
text-align: center;
line-height: 88px;
`;
const LoadingPop=styled.div`
    width:686px;
    height: 486px;
    padding:100px 28px 0 28px;
`;
const LoadingWrap=styled.div`
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: row;
`
const LoadingIcon=styled.img`
    width: 150px;
    height: 150px;
    border-radius: 10px;
`;
const InfoTitle=styled.div`
    margin-left:20px;
    font-size:28px;
    color: #333;
`;